import Typography from '@mui/material/Typography';

import { ConfidentialValue } from '../../ConfidentialValue';

import { ServiceCode } from './ServiceCode';
import { ServiceValueInfos } from './ServiceValueInfos';
import type { ServiceUsageCardCmp_Service } from './fragments/service.fragment';

interface Props {
  readonly maskAmounts?: boolean;
  readonly service: ServiceUsageCardCmp_Service;
}

export const ServiceInfos = ({
  maskAmounts = false,
  service,
}: Readonly<Props>) => {
  const { label, title, value } = service;

  return (
    <>
      <Typography
        component="div"
        gutterBottom
        sx={{ lineHeight: 1.2 }}
        variant="h6"
      >
        {label}
      </Typography>
      <ServiceCode service={service} />
      <Typography gutterBottom sx={{ flexGrow: 1 }} variant="body2">
        {title}
      </Typography>
      {!maskAmounts && (
        <>
          <Typography color="text.secondary" variant="overline">
            Informations Service
          </Typography>
          {value ? <ServiceValueInfos value={value} /> : <ConfidentialValue />}
        </>
      )}
    </>
  );
};
